var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('h1',[_vm._v(_vm._s(_vm.getMessage_('SWCC000131')))]),_c('h4',[_vm._v(_vm._s(_vm.getMessage_('SWCC000132')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }